import { z } from 'zod';

import { entityCreatedAtSchema } from '../../../utils';

/** Where a widget is placed: the document flow of a column / grid cell, or a zero block's free layout. */
export const WIDGET_PLACEMENTS = ['default', 'zero'] as const;

/**
 * Envelope every versioned widget shares — the widget counterpart of the
 * grid / tab / column base. Only infrastructure lives here; the widget's own
 * settings go in `props`, keyed per breakpoint at the leaf.
 *
 * `entityType` is `widget:<kind>` (`widget:line`) and `entitySubType` the
 * placement variant, as `default` / `specific` are for a block — a zero-block
 * widget is its own schema, since zero changes more of `props` than the position.
 *
 * `parentId` is the widget's direct container: the grid for a grid cell, the
 * column otherwise (legacy `structureId ?? columnId`). `meta.displayId` is the
 * user-set element id, as on a block; `meta.createdAt` is when the widget was
 * created (a copy is a new widget), `null` for one that predates the field.
 */
export const widgetBaseSchema = z.object({
    id: z.string(),
    parentId: z.string(),
    entityType: z.templateLiteral(['widget:', z.string()]),
    entitySubType: z.enum(WIDGET_PLACEMENTS),
    version: z.number().int().nonnegative(),
    meta: z.object({
        displayId: z.string().nullable(),
        createdAt: entityCreatedAtSchema,
    }),
});
